import { gql } from '@graphql/__generated__';

export const PORTAL_FRAGMENT = gql(/* GraphQL */ `
  fragment PortalFragment on portals {
    __typename
    id
    created_at
    updated_at
    created_by

    active
    contract_id
    email
    exact_address_required
    exclude_from_published_stats
    has_top_premium_listing
    idx_protocol
    master_portal_id
    name
    port
    quota
    type
    url
    website_url
    team_id
    ...PortalLogo

    portal_listings_aggregate(where: { live: { _eq: true } }) {
      aggregate {
        count
      }
    }
  }
`);

export const GET_PORTALS = gql(/* GraphQL */ `
  query GetPortals(
    $where: portals_bool_exp!
    $order_by: [portals_order_by!]!
    $limit: Int!
    $offset: Int!
  ) {
    portals(
      where: $where
      order_by: $order_by
      limit: $limit
      offset: $offset
    ) {
      ...PortalFragment
    }
  }
`);

export const GET_PORTALS_COUNT = gql(/* GraphQL */ `
  query GetPortalsCount($where: portals_bool_exp!) {
    portals_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`);

export const GET_PORTAL = gql(/* GraphQL */ `
  query GetPortal($id: uuid!) {
    portals_by_pk(id: $id) {
      id
      ...PortalFragment
      username
      password
    }
  }
`);

export const CHECK_PORTAL_CONNECTION = gql(/* GraphQL */ `
  query CheckPortalConnection($id: uuid!) {
    check_portal_connection(portal_id: $id) {
      success
      error
    }
  }
`);

export const IMPORT_PORTAL_LISTINGS = gql(/* GraphQL */ `
  mutation ImportPortalListings(
    $portal_id: uuid!
    $broker_id: uuid
    $dry_run: Boolean!
    $page: Int
    $page_size: Int
  ) {
    import_portal_listings(
      portal_id: $portal_id
      broker_id: $broker_id
      dry_run: $dry_run
      page: $page
      page_size: $page_size
    ) {
      page
      total_pages
      total_properties
      inserted
      updated
      errors
      items {
        external_property_id
        reference
        label
        outcome
        lot_id
        errors
        warnings
      }
    }
  }
`);

export const GET_PORTAL_LIVE_LISTINGS = gql(/* GraphQL */ `
  query GetPortalLiveListings($portal_id: uuid!) {
    portal_listings(
      where: { portal_id: { _eq: $portal_id }, live: { _eq: true } }
      order_by: { created_at: asc }
    ) {
      id
      lot_id
      external_property_id
      lot {
        id
        dummy_usable_surface
        property {
          id
          built_surface
          usable_surface
          living_surface
          gross_floor_surface
          weighted_floor_surface
        }
      }
    }
  }
`);

export const GET_PORTAL_TEAMS = gql(/* GraphQL */ `
  query GetPortalTeams($portal_id: uuid!) {
    portals_by_pk(id: $portal_id) {
      id
      team_id
      teams_portals {
        team_id
      }
    }
  }
`);

export const GET_PORTAL_TEAM_BROKERS = gql(/* GraphQL */ `
  query GetPortalTeamBrokers($team_ids: [uuid!]!) {
    teams_users(
      where: {
        team_id: { _in: $team_ids }
        deactivated: { _eq: false }
        user: { is_broker: { _eq: true } }
      }
      order_by: { user: { full_name: asc } }
    ) {
      user {
        id
        ...UserSelect
      }
    }
  }
`);

export const READ_PORTAL_IDX = gql(/* GraphQL */ `
  query ReadPortalIdx($id: uuid!) {
    read_portal_idx(portal_id: $id) {
      rows
      columns
      count
      truncated
    }
  }
`);

export const GET_PORTAL_METADATA = gql(/* GraphQL */ `
  query GetPortalMetadata {
    shared_portals {
      id
      name
    }
    portals_types_enum {
      value
    }
  }
`);

export const UPDATE_PORTAL = gql(/* GraphQL */ `
  mutation UpdatePortal($id: uuid!, $portal: portals_set_input!) {
    update_portals_by_pk(pk_columns: { id: $id }, _set: $portal) {
      ...PortalFragment
    }
  }
`);

export const UPSERT_PORTAL = gql(/* GraphQL */ `
  mutation UpsertPortal($portal: portals_insert_input!) {
    insert_portals_one(
      object: $portal
      on_conflict: {
        constraint: real_estate_portals_pkey
        update_columns: [
          active
          contract_id
          email
          exact_address_required
          exclude_from_published_stats
          has_top_premium_listing
          idx_protocol
          master_portal_id
          name
          password
          port
          quota
          type
          url
          username
          website_url
          team_id
          logo_image_id
        ]
      }
    ) {
      id
      ...PortalFragment
      username
      password
    }
  }
`);

export const DELETE_PORTAL = gql(/* GraphQL */ `
  mutation DeletePortal($id: uuid!) {
    delete_portals_by_pk(id: $id) {
      id
    }
  }
`);
